import React, { useContext } from 'react';
import styled from 'styled-components/macro';
import PageContainer from '../components/pages/PageContainer';
import PageTiles from "@components/layout/PageTiles";
import NewUser from '@components/user/NewUser';
import PriorUserNoCredits from '@components/user/PriorUserNoCredits';
import {UserContext} from "@stores/UserContext";
import {asedaCards, sciScoreCards} from "@app_config/home.cards";
import { MenuContext } from '@stores/MenuContext';
import { CreditsContext } from '@stores/CreditsContext';

const debug = false;
// Show the main page of tiles for the site (linked to the logo)
const PgHome = () => {
  const { user } = useContext(UserContext);
  const { creditsInfo } = useContext(CreditsContext);
  const { activeMenuId, setActiveMenuId } = useContext(MenuContext);
  debug && console.log("PgHome | userInfo:", user, 'creditsInfo:', creditsInfo);

  if (activeMenuId !== 'home') setActiveMenuId('home');

  return (
    <PageContainer title='Welcome'>
      { creditsInfo?.creditsUsed === 0 && creditsInfo?.creditsAvailable === 0 ?
        <NewUser /> : null
      }
      { creditsInfo?.creditsUsed !== 0 && creditsInfo?.creditsAvailable === 0 ?
        <PriorUserNoCredits /> : null
      }
      <Panel title={"SciScore Processes"}>
        <Title>SciScore Processes</Title>
        <PageTiles
            isAuthorized={user.isAppAuthorized}
            cards={sciScoreCards}
        />
      </Panel>
      <Panel>
        <Title>Additional AsedaSciences Information and Application/Services</Title>
        <PageTiles
            isAuthorized={user.isAppAuthorized}
            cards={asedaCards}
        />
      </Panel>
    </PageContainer>
  );
};

export default PgHome;

const Panel = styled.div`
  display: flex;
  margin-top: 40px;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
`;

const Title = styled.div`
  display: flex;
  font-size: 20px;
  color: ${(p) => p.theme.palette.accentPrimary};
`;

